import * as Select from '@radix-ui/react-select';

import { DropdownItem } from '~/chords/DropdownSingleSelect/components/DropdownItem';
import type {
  InternalDropdownOption,
  OptionTemplateComponent,
  RadixUiProps,
} from '~/chords/DropdownSingleSelect/types';

interface DropdownItemsProps extends RadixUiProps {
  options: InternalDropdownOption[];
  searchQuery?: string;
  selectedOption?: InternalDropdownOption;
  onSelectOption?: (option: InternalDropdownOption) => void;
  showCheckIcon?: boolean;
  OptionTemplate?: OptionTemplateComponent;
}

export function DropdownItems({
  options,
  searchQuery,
  selectedOption,
  onSelectOption,
  showCheckIcon,
  OptionTemplate,
  radix = {},
}: DropdownItemsProps) {
  return (
    <Select.Group {...radix.selectGroup}>
      {options.map((option) => (
        <DropdownItem
          key={option.value}
          option={option}
          selectedOption={selectedOption}
          onSelectOption={onSelectOption}
          showCheckIcon={showCheckIcon}
          searchQuery={searchQuery}
          OptionTemplate={OptionTemplate}
          radix={radix}
        />
      ))}
    </Select.Group>
  );
}

DropdownItems.displayName = 'DropdownItems';
